const shopLocale = document.body.dataset.locale;
const alertMessage = (limit) => {
  if (shopLocale === "en") return `Limit: ${limit} per customer.`;
  return `この商品はお一人様 ${limit} 個までの購入制限があります。`;
};

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => this.onChange(event), ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === "cart-items") return;
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (input) input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace("[min]", event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace("[max]", event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace("[step]", event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  // ===============================
  // カート更新処理
  // ===============================
  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((res) => res.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, "text/html");
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const target = document.querySelector(selector);
            const source = html.querySelector(selector);
            if (target && source) target.replaceWith(source);
          }
        })
        .catch(console.error);
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((res) => res.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, "text/html");
          const source = html.querySelector("cart-items");
          this.innerHTML = source.innerHTML;
        })
        .catch(console.error);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
      { id: "cart-live-region-text", section: "cart-live-region-text", selector: ".shopify-section" },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  // ===============================
  // 数量変更ハンドラ（購入制限チェック含む）
  // ===============================
  updateQuantity(line, quantity, event, name, variantId) {
    const itemEl =
      document.getElementById(`CartItem-${line}`) ||
      document.getElementById(`CartDrawer-Item-${line}`);

    if (itemEl) {
      const newQty = parseInt(quantity, 10);
      const productId = itemEl.dataset.productId;
      if (!productId) {
        console.warn("⚠️ productId not found on itemEl");
        return;
      }

      // --- limit fallback ---
      const limit =
        parseInt(itemEl.dataset.limit || 0, 10) ||
        parseInt(itemEl.closest("[data-product-id]")?.dataset.limit || 0, 10) ||
        parseInt(itemEl.dataset.originalLimit || 0, 10) ||
        Number(window.productOrderLimit || 0);

      const purchased =
        parseInt(itemEl.dataset.purchased || 0, 10) ||
        parseInt(itemEl.closest("[data-product-id]")?.dataset.purchased || 0, 10) ||
        0;

      // --- カート全体で同一product_idの合計数量を集計（value＝すでに新しい値） ---
      const allItems = Array.from(document.querySelectorAll(`[data-product-id="${productId}"]`));
      let sameProductTotal = 0;
      for (const el of allItems) {
        const input =
          el.querySelector('[name^="updates"]') ||
          el.querySelector('input[name="quantity"]');
        const val = input ? parseInt(input.value, 10) || 0 : 0;
        sameProductTotal += val;
      }

      // ここが肝：DOMの value は「変更後の数」なので補正しない
      const totalAfter = sameProductTotal + purchased;

      if (limit > 0 && totalAfter > limit) {
        // ユーザーに伝える残数（この変更を適用しない前提での残り）
        const rest = Math.max(0, limit - (sameProductTotal - newQty + purchased));
        alert(
          rest <= 0
            ? alertMessage(limit)
            : `${alertMessage(limit)}\nあと ${rest} 個まで購入可能です。`
        );

        // 入力を元に戻す
        const currentInput =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        if (currentInput) currentInput.value = currentInput.getAttribute("value");

        this.disableLoading(line);
        return;
      }

    }

    // --- 通常処理 ---
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((s) => s.section),
      sections_url: window.location.pathname,
    });
    const eventTarget =
      event.currentTarget instanceof CartRemoveButton ? "clear" : "change";

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((res) => res.text())
      .then((state) => {
        const parsed = JSON.parse(state);
        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityEl =
            document.getElementById(`Quantity-${line}`) ||
            document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll(".cart-item");

          if (parsed.errors) {
            quantityEl.value = quantityEl.getAttribute("value");
            this.updateLiveRegions(line, parsed.errors);
            return;
          }

          this.classList.toggle("is-empty", parsed.item_count === 0);
          const drawer = document.querySelector("cart-drawer");
          const footer = document.getElementById("main-cart-footer");
          if (footer) footer.classList.toggle("is-empty", parsed.item_count === 0);
          if (drawer) drawer.classList.toggle("is-empty", parsed.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const el =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);
            el.innerHTML = this.getSectionInnerHTML(parsed.sections[section.section], section.selector);
          });

          const updatedValue = parsed.items[line - 1]
            ? parsed.items[line - 1].quantity
            : undefined;
          let message = "";
          if (
            items.length === parsed.items.length &&
            updatedValue !== parseInt(quantityEl.value)
          ) {
            if (typeof updatedValue === "undefined") {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace("[quantity]", updatedValue);
            }
          }
          this.updateLiveRegions(line, message);
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsed,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((o) => o.classList.add("hidden"));
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => this.disableLoading(line));
  }

  updateLiveRegions(line, message) {
    const err =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (err) err.querySelector(".cart-item__error-text").textContent = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);
    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);
    setTimeout(() => cartStatus.setAttribute("aria-hidden", true), 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const container =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    container.classList.add("cart__items--disabled");
    const spinners = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner, #CartDrawer-Item-${line} .loading__spinner`
    );
    spinners.forEach((o) => o.classList.remove("hidden"));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const container =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    container.classList.remove("cart__items--disabled");
    const spinners = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner, #CartDrawer-Item-${line} .loading__spinner`
    );
    spinners.forEach((o) => o.classList.add("hidden"));
  }
}
customElements.define("cart-items", CartItems);

// ===============================
// Cart Note
// ===============================
if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            }).then(() =>
              CartPerformance.measureFromEvent("note-update:user-action", event)
            );
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
